import React, { Component } from "react";
import BaseComponent from "../BaseComponent.js";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";

import NanoFlex from "./../Global/NanoFlex";
import Type from "./../Global/Typography";
import Header from "./Header.js";
import Navbar from "./Navbar.js";
import Footer from "./Footer.js";
import Modal from "../Global/Modal.js";
import SaveSearchModal from "./../Micro/SaveSearchModal.js";
import ModalContent from "./../Micro/ModalContent.js";
import SearchResult from "./../Macro/SearchResult.js";

const StyledLayout = styled(NanoFlex)`
  height: ${(props) => (props.fullHeight ? "100%" : "auto")};
  .viewsLayout {
    .layoutContainer {
      min-height: calc(100vh - 48px);
      justify-content: space-between;
      min-width: 0;
    }
  }
  /* MEDIA QUERIES */
  @media only screen and (max-width: 800px) {
    .viewsLayout {
      .layoutContainer {
        margin-bottom: 40px;
        min-height: calc(100vh - 88px);
      }
    }
  }
`;

const StyledLayoutBody = styled(NanoFlex)`
  display: ${(props) => (props.visible ? "flex" : "none")};
  /* z-index: 1; */
`;

class Layout extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      filter: {},
      advancedSearch: {},
      displaySearch: false,

      openSaveSearchModal: false,
      saveSearchFilter: {},
    };

    this.filter = {};
    this.advancedSearch = {};
    this.advancedSearchVisible = false;
  }

  componentDidMount() {
    super.componentDidMount();
    window.addEventListener("closeAdvancedSearch", this.onCloseAdvancedSearch, false);
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    window.removeEventListener("closeAdvancedSearch", this.onCloseAdvancedSearch, false);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.render !== this.props.render) {
      this.setState({ displaySearch: false });
      window.dispatchEvent(new Event("closeAdvancedSearch"));
      window.dispatchEvent(new Event("clearSearch"));
      if (window.scrollY !== 0) window.scrollTo({ top: 0, behavior: "auto" });
    }

    if (prevState.displaySearch !== this.state.displaySearch) {
      window.dispatchEvent(new CustomEvent("displaySearchChanged", { detail: this.state.displaySearch }));
    }
  }

  onCloseAdvancedSearch = () => {
    this.advancedSearchVisible = false;
  };

  onFilterChange = (filter) => {
    this.filter = filter;
    this.validateDisplaySearch("filter");
  };

  onAdvancedSearchVisibleChange = (visible) => {
    this.advancedSearchVisible = visible;
    this.validateDisplaySearch("visibleChange");
  };

  onAdvancedSearchChange = (filter) => {
    if (this.advancedSearch.searchFrom !== filter.searchFrom || this.advancedSearch.savedSearchId !== filter.savedSearchId || this._isMobile) {
      window.dispatchEvent(new Event("closeAdvancedSearch"));
    }
    this.advancedSearch = filter;
    this.validateDisplaySearch("advancedSearch");
  };

  getSearchFilter = () => {
    return { ...this.state.advancedSearch, ...this.state.filter };
  };

  validateDisplaySearch = (validateFrom) => {
    if (this.advancedSearchVisible && validateFrom === "filter") {
      return;
    }

    switch (this.advancedSearch.searchFrom) {
      case "QuickSearch":
        let minCharSearch = this.getLanguage() == 1 ? 2 : 3;
        //Quick Search Rules
        if (this.filter.term && this.filter.term.length >= minCharSearch) {
          if (this.filterCanUpdate(true)) {
            this.setState({ displaySearch: true, filter: { ...this.filter }, advancedSearch: { ...this.advancedSearch } });
          }
        } else {
          if (this.filterCanUpdate(false)) {
            this.setState({ displaySearch: false });
          }
        }
        break;
      case "AdvancedSearch":
      default:
        //Advanced Search Rules
        if (this.filterCanUpdate(true)) {
          this.setState({ displaySearch: true, filter: { ...this.filter }, advancedSearch: { ...this.advancedSearch } });
        }
        break;
    }
  };

  filterCanUpdate = (displaySearch) => {
    return this.state.displaySearch !== displaySearch || JSON.stringify(this.filter) !== JSON.stringify(this.state.filter) || JSON.stringify(this.advancedSearch) !== JSON.stringify(this.state.advancedSearch);
  };

  getSelectedMenu = () => {
    let selectedMenu = this.advancedSearch ? this.advancedSearch.searchFrom : "";
    if (!this.state.displaySearch) {
      selectedMenu = this.props.render.match.params.menu;
    }
    if (selectedMenu === "AdvancedSearch" && this.isSearchInvalid()) {
      return "";
    }
    return selectedMenu;
  };

  isSearchInvalid = (f) => {
    let filter = f ?? this.getSearchFilter();
    return filter.isDefault && filter.term?.trim() === "";
  };

  render() {
    const { displaySearch, filter } = this.state;
    return (
      <StyledLayout fullHeight={this.props.fullHeight && !displaySearch} flexDirection={"column"}>
        <Header render={this.props.render} displaySearch={displaySearch} filter={filter} advancedSearch={this.state.advancedSearch} selectedMenu={this.getSelectedMenu()} onFilterChange={this.onFilterChange} />
        <NanoFlex className="viewsLayout" alignItems={"flex-start"}>
          <Navbar
            render={this.props.render}
            savedSearchId={this.advancedSearch ? this.advancedSearch.savedSearchId : null}
            selectedMenu={this.getSelectedMenu()}
            advancedSearchVisible={this.advancedSearchVisible}
            onAdvancedSearchVisibleChange={this.onAdvancedSearchVisibleChange}
            onAdvancedSearchChange={this.onAdvancedSearchChange}
            onAdvancedSearchSave={(filter) => {
              this.setState({ openSaveSearchModal: true, saveSearchFilter: filter });
            }}
          />
          <NanoFlex className="layoutContainer" flexDirection={"column"} justifyContent={"flex-start"} alignItems={"center"}>
            <StyledLayoutBody className="layoutBodyContainer" visible={!displaySearch}>
              {React.cloneElement(this.props.children, { render: this.props.render })}
            </StyledLayoutBody>
            {displaySearch && <SearchResult filter={this.getSearchFilter()} isSearchInvalid={this.isSearchInvalid()} />}
            <Footer />
          </NanoFlex>

          {/* Only allow save search if it is not Invalid */}
          <Modal
            show={this.state.openSaveSearchModal && this.isSearchInvalid({ ...this.state.saveSearchFilter, ...this.filter }) == false}
            content={<SaveSearchModal visible={this.state.openSaveSearchModal} filter={{ ...this.state.saveSearchFilter, ...this.filter }} cancelAction={() => this.setState({ openSaveSearchModal: false })} nextAction={() => this.setState({ openSaveSearchModal: false })} />}
          />
          <Modal
            show={this.state.openSaveSearchModal && this.isSearchInvalid({ ...this.state.saveSearchFilter, ...this.filter })}
            content={
              <ModalContent
                message={this.translation.advancedSearch.invalidSearchMessage}
                actions={[
                  {
                    label: this.translation.geral.continue,
                    action: () => {
                      this.setState({ openSaveSearchModal: false });
                    },
                    simple: false,
                  },
                ]}
              />
            }
          />
        </NanoFlex>
      </StyledLayout>
    );
  }
}

export default Layout;
